'use client';

import type { ReactElement } from 'react';
import { TbPlugConnected } from 'react-icons/tb';

import type { IntegrationBlockPayload } from './types';

export function IntegrationBlock({ payload }: { payload: IntegrationBlockPayload }): ReactElement {
  if (!payload.supported) {
    return (
      <div className="border-border-subtle/60 bg-surface-elevated/40 rounded-2xl border p-4">
        <p className="text-ink text-sm font-semibold">Integracao nao suportada</p>
        <p className="text-ink-muted mt-1 text-xs">Veja todas as integracoes disponiveis.</p>
        <a
          href="/integracoes"
          className="bg-trakd-fill text-on-brand mt-3 inline-block rounded-lg px-3 py-2 text-xs font-semibold"
        >
          Ver integracoes
        </a>
      </div>
    );
  }
  return (
    <div className="border-border-subtle/60 bg-surface-elevated/40 rounded-2xl border p-4">
      <div className="flex items-center gap-3">
        <span className="bg-trakd-fill text-on-brand flex h-9 w-9 items-center justify-center rounded-lg">
          <TbPlugConnected size={18} />
        </span>
        <div>
          <p className="text-ink text-sm font-bold">{payload.name}</p>
          <p
            className={
              payload.connected ? 'text-success text-[11px]' : 'text-ink-muted text-[11px]'
            }
          >
            {payload.connected ? 'Conectada' : 'Nao conectada'}
          </p>
        </div>
      </div>
      {(payload.steps ?? []).length > 0 && (
        <ul className="mt-3 space-y-1">
          {(payload.steps ?? []).map((s, i) => (
            <li key={i} className="text-ink-muted text-[11px]">
              › {s}
            </li>
          ))}
        </ul>
      )}
      <a
        href={payload.href}
        className="bg-trakd-fill text-on-brand mt-3 inline-block w-full rounded-lg py-2 text-center text-xs font-semibold"
      >
        {payload.connected ? `Abrir detalhes da ${payload.name}` : `Conectar ${payload.name}`}
      </a>
    </div>
  );
}
